import { render } from "./OperatorsPage.vue?vue&type=template&id=89987124"
import script from "./OperatorsPage.vue?vue&type=script&lang=js"
export * from "./OperatorsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__